import { useQuery } from '@tanstack/react-query';
import { listMails, listRootMails } from '@/services/api/endpoints';
import type { MailSummary } from '@/types/domain';

// Mails filed directly in a folder. Only fetched when the folder is expanded
// (the consuming component mounts lazily), so collapsed folders cost nothing.
export function useMails(folderId: string | null) {
  return useQuery<MailSummary[]>({
    queryKey: ['mails', folderId],
    queryFn: () => listMails(folderId as string),
    enabled: Boolean(folderId),
    staleTime: 15_000,
  });
}

// Mails filed at a project ROOT (folder_id null). Key is distinct from folder
// mails so the two lists invalidate independently.
export function useRootMails(containerId: string | null) {
  return useQuery<MailSummary[]>({
    queryKey: ['mails', 'root', containerId],
    queryFn: () => listRootMails(containerId as string),
    enabled: Boolean(containerId),
    staleTime: 15_000,
  });
}
